export const setToken = 'auth/setToken'
export const setUser = 'auth/setUser'



// WEBPACK FOOTER //
// ./src/domain/auth/store/mutations-types.js